/**
 * Work too heavy for two of it to share a frame -- a storey drawn afresh, a storey's sun shadows re-cast -- takes turns:
 * the first job of a frame claims it, and the rest wait for the frames after. A block laid in a castle redrew two storeys
 * and re-cast their shadows all in one or two frames (~170ms of script); taking turns, the same work lands one job a
 * frame, each a fraction of that, and the block itself is drawn in the first.
 *
 * Callers exempt a storey's FIRST drawing and first cast in a room: a room arriving should be whole when it is revealed,
 * not filled in storey by storey.
 */

let frame = 0
let claimedFrame = -1

/** A new frame: its turn is free again. The renderer calls this as each frame starts. */
export const startFrameWork = (): void => {
    frame++
}

/**
 * Whether a heavy job may run this frame. True for the first asker each frame (who then holds it), false for the rest,
 * who ask again next frame. Before any frame has started (tests, tools rendering offscreen) every job may run.
 */
export const claimHeavyWork = (): boolean => {
    if (frame === 0) return true
    if (claimedFrame === frame) return false
    claimedFrame = frame
    return true
}

/** Whether heavy work is taking turns at all: false before the first frame (tests, offscreen tools), where all of it runs at once. */
export const heavyWorkTakesTurns = (): boolean => frame > 0

/** For tests: back to no frame started. */
export const resetFrameWork = (): void => {
    frame = 0
    claimedFrame = -1
}
